import { useContext } from "react";
import { PurchaseContext } from "./PurchaseContext";

export const usePurchase = () => {
    const context = useContext(PurchaseContext);

    if (context === undefined) {
        throw new Error("usePurchase must be used within an PurchaseProvider");
    }

    return context;
};
